<template>
    <div class="mt-6 md:mt-8 p-2 flex items-center border border-gray-400" :class="backgroundColor">
        <div class="text-center mx-auto">
            <span class="text-xl ml-2 mr-1 text-gray-700 inline-block">
                <i class="fa fa-exclamation-triangle"></i>
            </span>
            <div class="text-gray-600 ml-1 text-base" v-if="showSlot">
                <slot name="body"></slot>
            </div>
            <span v-else class="text-gray-600 ml-1 text-base">
                {{ body }}
            </span>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    body: String,
    backgroundColor: {
        type: String,
        default: 'bg-gray-100'
    }
});

const showSlot = ref(!props.body);
</script>
